import React from 'react';
import { Stack } from '@mui/material';
import { AnalyticsBox } from 'components/AnalyticsBox/AnalyticsBox';
import { AnalyticsPieBox } from 'components/AnalyticsBox/AnalyticsPieBox/AnalyticsPieBox';
import { FINANCE_BREAKDOWNS_ANALYTICS, AnalyticsTabProps } from './utils';

const AnalyticsFinanceTab: React.FC<AnalyticsTabProps> = ({
  xAxisDateFormat,
  isLoading,
  filteredAnalytics,
  formattedAnalytics,
  analytics
}) => {
  const breakdownAnalytics = FINANCE_BREAKDOWNS_ANALYTICS.map((metric) => {
    const breakdown = analytics.getBreakdowns.data?.find(
      (breakdown) => breakdown.name === metric
    );
    return breakdown;
  });

  return (
    <Stack direction="column">
      <div className="grid grid-cols-3 gap-4">
        {breakdownAnalytics.map((breakdown) => (
          <AnalyticsPieBox breakdown={breakdown} isLoading={isLoading} />
        ))}
        {filteredAnalytics.map((metricName) => {
          const item = formattedAnalytics[metricName];
          return (
            <AnalyticsBox
              key={metricName}
              metricName={metricName}
              stat={item?.stat}
              currentTrends={item?.currentTrends ?? []}
              previousTrends={item?.previousTrends}
              isLoading={isLoading}
              xAxisDateFormat={xAxisDateFormat}
            />
          );
        })}
      </div>
    </Stack>
  );
};

export default AnalyticsFinanceTab;
